import React from "react";


function FundingHeader() {

    return (
        <>
            <div className="pd-header">

                <div className="header-bottom">
                    <h2 className="pd-title">Funding</h2>
                </div>
            </div>
        </>
    );
}

export default FundingHeader;
